import TableActionButtons from '@/components/common/TableActionButtons';
import Table from '@/components/table/Table';
import { DEFAULT_SELECT_PAGE_SIZES, PRICE_STATUS_CONFIG, ROUTES } from '@/configs/constants';
import { useStore } from '@/hooks/useStore';
import { ColumnDef, TableState, Updater } from '@tanstack/react-table';
import { flowResult } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default observer(function PriceManagementPage() {
    // hook
    const { t } = useTranslation();
    const nav = useNavigate();

    // store
    const {
        priceStore: { priceList, getPriceList, paging, totalRecord, clean }
    } = useStore();

    // state
    const [rowSelected, setRowSelected] = useState({});

    // lifecycle
    useEffect(() => {
        onSearch();
    }, []);

    // function
    const fetchDataPrices = async (searchParams?: any, paging?: TableState) => {
        await flowResult(getPriceList(searchParams, paging));
    };

    const onSearch = (searchParams?: any, paging?: TableState) => {
        clean();
        fetchDataPrices(searchParams, paging);
    };

    const onStateChange = (stateUpdater: Updater<TableState>) => {
        const newPaging = stateUpdater instanceof Function ? stateUpdater(paging) : stateUpdater;
        fetchDataPrices(undefined, newPaging);
    };

    const handleEditPrice = (id: string) => {
        nav(`${ROUTES.priceEdit.href}/${id}`);
    };

    // const handleDeletePrice = (id: string) => {
    //     showAlertModal({
    //         isConfirmModal: true,
    //         content: t('messages.confirm_delete'),
    //         cancelButton: t('button.cancel'),
    //         saveButton: t('button.ok'),
    //         onSave: async () => {
    //             onDeletePriceById(id);
    //         }
    //     });
    // };

    // const onDeletePriceById = async (id: string) => {
    //     const res = await flowResult(deletePrice(id));
    //     if (res?.ok) {
    //         showAlertModal({
    //             id: 'success',
    //             type: 'success',
    //             content: t('messages.delete_success'),
    //             onClickXIcon: () => {
    //                 getPriceList(paging);
    //             }
    //         });
    //     }
    // };

    // const handleViewPrice = (id: string) => {
    //     nav(`${ROUTES.priceDetail.href}/${id}`);
    // };

    // columns
    const columns: ColumnDef<any>[] = [
        // {
        //     id: 'id',
        //     accessorKey: 'id',
        //     header: t('field.stt'),
        //     size: 80,
        //     enableSorting: false,
        //     cell: ({ row }) => {
        //         const { pageIndex, pageSize } = paging.pagination;
        //         const index = (row.index + 1) + (pageIndex * pageSize);
        //         return index;
        //     }
        // },
        {
            id: 'actions',
            accessorKey: 'actions',
            header: '',
            size: 50,
            enableSorting: false,
            cell: ({ row: { original } }) => (
                <div className=''>
                    <TableActionButtons
                        onView={() => handleEditPrice(original.id)}
                    />
                </div>
            )
        },
        {
            accessorKey: 'name',
            header: t('field.price_name'),
            size: 400,
            enableSorting: false
        },
        {
            accessorKey: 'status',
            header: t('field.status'),
            size: 400,
            enableSorting: false,
            cell: ({ row: { original } }) => (
                <span className={`${PRICE_STATUS_CONFIG[original?.status]?.textColor}`}>{t(`${PRICE_STATUS_CONFIG[original?.status]?.key}`)}</span>
            )
        }
        // {
        //     accessorKey: 'createBy',
        //     header: t('field.price_create_by'),
        //     size: 400,
        //     enableSorting: false,
        //     cell: ({ row: { original } }) => (
        //         <div className=''>
        //             <span>{original.createBy}</span>
        //         </div>
        //     )
        // },
        // {
        //     accessorKey: 'createdAt',
        //     header: t('field.price_create_time'),
        //     size: 400,
        //     enableSorting: false,
        //     cell: ({ row: { original } }) => (
        //         <div className=''>
        //             <span>
        //                 {
        //                     formatDateTime(original.createdAt, DATE_YMD_2)
        //                 }
        //             </span>
        //         </div>
        //     )
        // },

    ];

    return (
        <div className='layout-card'>
            {/* <div className='flex justify-end gap-4 mb-5'>
                <Link to={ROUTES.priceCreate.href}>
                    <ButtonCus variant='default' size='md'>
                        <CirclePlus className='mr-2' />
                        {t('button.add_new')}
                    </ButtonCus>
                </Link>
            </div> */}
            <Table
                columns={columns}
                data={priceList}
                state={{
                    ...paging,
                    rowSelection: rowSelected
                }}
                showSelectPageSize={false}
                rowCount={totalRecord}
                onStateChange={onStateChange}
                selectPageSizes={DEFAULT_SELECT_PAGE_SIZES}
                enableRowSelection={false}
                onRowSelectionChange={setRowSelected}
                getRowId={row => row.id?.toString()}
            />
        </div>
    );
});
